var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{attrs:{"id":"audiobeep","src":"/other/beep.mp3","preload":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }